// @ts-strict-ignore
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Card, DataListItem } from '@node-space/ui-components'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

interface ContactCardProps {
  name: string
  showAvatar?: boolean
  title?: string
}

export const ContactCard = ({ name, showAvatar = true, title = '' }: ContactCardProps) => {
  const { t } = useTranslation()
  const { enableAddAccountSheet } = useFeatureFlags()

  const titleText = useMemo(() => {
    const fallbackTitle = enableAddAccountSheet
      ? t('contacts.addingToContact')
      : t('contacts.contact')

    return title || fallbackTitle
  }, [enableAddAccountSheet, title, t])

  return (
    <Card variant="static" emphasis full>
      <DataListItem
        size="large"
        layout="vertical"
        id="contact-card"
        title={titleText}
        BodyAvatar={showAvatar && <Avatar size="small" type="entity" name={name ?? ''} />}
        body={name}
      />
    </Card>
  )
}
